import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

import Component from '../../components/component/component';
import {
    debounce,
    DebouncedFunction,
} from '../../components/helpers/helpers';

import './table-slider.scss';

export default class TableSlider extends Component {
    static initSelector: string = '.table-slider';

    slider: HTMLElement;
    columns: NodeListOf<HTMLElement>;
    desktopColumnsCount: number;
    mobileColumnsCount: number;
    debouncedResizeHandler: DebouncedFunction<() => void>;

    constructor(target: HTMLElement) {
        super(target);

        this.slider = this.element.querySelector('.table-slider__slider');
        this.columns = this.element.querySelectorAll('.table-slider__list-item');
        this.mobileColumnsCount = parseInt(this.slider.getAttribute('data-mobile-columns'));
        this.desktopColumnsCount = parseInt(this.slider.getAttribute('data-desktop-columns'));
        this.debouncedResizeHandler = debounce(this.calculateRowHeight.bind(this), 50);

        this.init();
    }

    init(): void {
        const initDesktop: boolean = this.columns.length > this.desktopColumnsCount;
        const initMobile: boolean = this.columns.length > this.mobileColumnsCount;

        if (initDesktop || initMobile) {
            new Splide('.table-slider__slider', {
                autoplay: false,
                breakpoints: {
                    768: {
                        // based on the need of desktop slider initiation, add following properties
                        ...(!initDesktop && {destroy: true}),
                        ...(initDesktop && {perPage: this.desktopColumnsCount}),
                    },
                },
                classes: {
                    arrow: 'splide__arrow table-slider__arrow',
                    next: 'splide__arrow--next table-slider__arrow--next',
                    prev: 'splide__arrow--prev table-slider__arrow--prev',
                },
                gap: 0,
                mediaQuery: 'min',
                pagination: false,
                perMove: 1,
                perPage: this.mobileColumnsCount,
                type: 'slide',
            }).mount();
        }

        setTimeout(() => {
            this.calculateRowHeight();
        }, 500);
        window.addEventListener('resize', this.debouncedResizeHandler);
    }

    calculateRowHeight(): void {
        const heightArray: number[] = [];

        const rowAmount: number = this.columns[0].querySelectorAll('.table-slider__cell').length;

        for (let i: number = 0; i < rowAmount; i++) {
            heightArray.push(0);
        }

        this.columns.forEach((element: HTMLElement) => {
            const cells: NodeListOf<HTMLElement> = element.querySelectorAll('.table-slider__cell');

            cells.forEach((cell: HTMLElement, index: number) => {
                cell.style.height = '';
                const height: number = cell.clientHeight;

                if (heightArray[index] < height) {
                    heightArray[index] = height;
                }
            });
        });

        this.columns.forEach((element: HTMLElement) => {
            const cells: NodeListOf<HTMLElement> = element.querySelectorAll('.table-slider__cell');

            cells.forEach((cell: HTMLElement, index: number) => {
                cell.style.height = `${heightArray[index]}px`;
            });
        });
    }
}

